// Gleicht die Ziele je Stufe in den Wizard Zustand ab. Quelle ist GET /api/cicd/stage-branches/config (Vertrag V.12),
// freigegeben für Transportbenutzer; die Pipeline Übersicht gehört dem Monitor. Gelesen wird nur, wenn der Space eine
// Stufe mit mehreren Instanzen hat; sonst gibt es keinen zusätzlichen Abruf. Ein Lesefehler lässt den letzten Stand
// unverändert (kein stiller Wechsel aus dem Mehrzielmodus), abgeglichen wird nur nach erfolgreichem Lesen. Fehler und
// „Erneut lesen“ stehen über StageTargetsReadContext für Scene 0 bereit.
import { createContext, useContext, useEffect, useMemo } from "react";
import { useTransportV2 } from "../context/TransportV2Context";
import { useStageBranchesConfig } from "../../../stage-branches/useStageBoard";

export const StageTargetsReadContext = createContext({ error: null, reload: () => {} });
export const useStageTargetsRead = () => useContext(StageTargetsReadContext);

export function useStageTargetsSync() {
  const { state, dispatch } = useTransportV2();
  const needed = !!state.space?.stages?.some(stage => stage.candidates?.length);
  const { config, loading, error, reload } = useStageBranchesConfig(needed ? state.spaceId : null);
  // Nach einem Reset (stageTargetsRead false) gilt die bereits gelesene Config erneut.
  useEffect(() => {
    if (!needed || loading || error || !config) return;
    const multi = config.multiTarget === true && !!config.stageTargets;
    dispatch({ type: "SET_STAGE_TARGETS", payload: { multiTarget: multi, stageTargets: multi ? config.stageTargets : null, ...(multi && config.plantTargets ? { plantTargets: config.plantTargets } : {}) } });
  }, [needed, loading, error, config, state.stageTargetsRead]); // eslint-disable-line react-hooks/exhaustive-deps
  const shown = needed && !loading ? error : null;
  return useMemo(() => ({ error: shown, reload }), [shown, reload]);
}
